import {ButtonSize} from '../../../types/Forms';
import {Step} from '../../../types/Stepper';

interface ButtonProps {
    stepNumber: number;
    buttonNumber: number;
    label: string;
    size: ButtonSize;
    icon?: JSX.Element;
    filterMessagesOnClick?: (label: Step) => void;
}

const pillSize: Record<ButtonSize, string> = {
    small: 'h-40px w-40px',
    medium: 'h-60px w-60px',
    large: 'h-100px w-100px',
};

const StepperButton = ({
    stepNumber,
    buttonNumber,
    label,
    size,
    icon,
    filterMessagesOnClick,
}: ButtonProps): JSX.Element => {
    const isStepPassed = stepNumber >= buttonNumber;
    const isCurrentStep = stepNumber === buttonNumber;

    const stepLabel = isStepPassed ? <span>{label}</span> : <i>{label}</i>;

    return (
        <div className="d-flex flex-column mb-lg-3">
            <div className="d-flex position-relative justify-content-center">
                <div
                    className={`d-flex justify-content-center align-items-center btn btn-rounded rounded-circle ${
                        isStepPassed ? 'bg-celeste-primary' : 'bg-secondary'
                    } bg-opacity-65 ${pillSize[size]}`}
                    {...(filterMessagesOnClick !== undefined && {
                        onClick: () => filterMessagesOnClick(label),
                    })}
                >
                    <span
                        className={`${isStepPassed ? 'text-white' : 'text-black'} ${
                            isCurrentStep ? 'fs-1' : ''
                        }`}
                    >
                        {icon ?? buttonNumber}
                    </span>
                </div>
                <div className="d-none d-lg-flex position-absolute top-100 d-flex p-2">
                    <p className={`${isCurrentStep ? 'fs-3 fw-bold' : ''} text-center`}>
                        {stepLabel}
                    </p>
                </div>
                <div className="d-flex d-lg-none position-absolute w-150px start-100 top-25 d-flex pt-2 ps-5">
                    <p className={isCurrentStep ? 'fs-3 fw-bold' : ''}>{stepLabel}</p>
                </div>
            </div>
        </div>
    );
};

export default StepperButton;
